import React from 'react';

import { FilterSelect, PrimaryFilters } from 'filters';
import { FILTER_PERIOD } from 'scenes/DashboardPage/constants';
import { loadPeriods } from 'scenes/DashboardPage/sources/filters/loadPeriods';

const FiltersPrimary = ({ initialValues = {}, onSubmit }: any) => {
  return (
    <PrimaryFilters initialValues={initialValues} onSubmit={onSubmit}>
      <FilterSelect
        name={FILTER_PERIOD}
        source={loadPeriods}
        label={'Period'}
      />
    </PrimaryFilters>
  );
};

export default FiltersPrimary;
